import { jsx as t, jsxs as r } from "react/jsx-runtime";
import m from "react";
import i from "styled-components";
import { b, a as u, _ as x } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { c as v, u as h } from "../chunks/useClickMotion.0a3ea4e5.js";
import { R as y } from "../chunks/Description.be3b00d1.js";
import "../chunks/Heading.2a0f9b41.js";
import "../chunks/Paragraph.60dac1f9.js";
import { R as w, I as C } from "../chunks/index.cff5baaf.js";
const c = i.span.withConfig({
  displayName: "Container",
  componentId: "sc-18bbzdi-0"
})(["display:flex;justify-content:center;align-items:center;position:relative;z-index:0;gap:var(--spacing-2x);width:100%;&::after{content:'';position:absolute;z-index:-1;top:calc(-1 * var(--spacing-1x));left:calc(-1 * var(--spacing-1x));right:calc(-1 * var(--spacing-1x));bottom:calc(-1 * var(--spacing-1x));box-sizing:content-box;margin:auto;width:100%;padding:var(--spacing-1x);height:100%;border-radius:var(--border-radius-sm);transition-property:background-color,opacity;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-02);}"]), k = i.button.withConfig({
  displayName: "Button",
  componentId: "sc-18bbzdi-1"
})(["all:unset;display:flex;justify-content:center;align-items:center;width:fit-content;min-height:var(--size-6x);cursor:pointer;box-sizing:border-box;border-radius:var(--border-radius-sm);&:focus-visible{", " outline-offset:2px;}&:hover{", "::after{", " transition-timing-function:var(--curve-productive-entrance);}}"], b, c, u), z = i.span.withConfig({
  displayName: "MotionLayer",
  componentId: "sc-18bbzdi-2"
})(["position:absolute;z-index:-1;top:calc(-1 * var(--spacing-1x));left:calc(-1 * var(--spacing-1x));padding:var(--spacing-1x);width:100%;height:100%;"]), M = i.span.withConfig({
  displayName: "MotionLayerClick",
  componentId: "sc-18bbzdi-3"
})(["", " width:calc(100% + var(--spacing-2x));height:calc(100% + var(--spacing-2x));display:inline-flex;position:relative;justify-content:center;align-items:center;margin:calc(-1 * var(--spacing-1x));border-radius:var(--border-radius-sm);"], (o) => o.$isClickMotion && v()), s = i.span.withConfig({
  displayName: "Label",
  componentId: "sc-18bbzdi-4"
})(["color:var(--text-label-color);", ""], x), l = i(y).withConfig({
  displayName: "Description",
  componentId: "sc-18bbzdi-5"
})([""]), I = i.div.withConfig({
  displayName: "Content",
  componentId: "sc-18bbzdi-6"
})(["display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;gap:var(--spacing-half);overflow:hidden;text-overflow:ellipsis;word-break:break-all;max-width:198px;", ",", "{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;}"], s, l), N = m.forwardRef(({
  label: o = "",
  description: n = "",
  onClick: a,
  ...d
}, p) => {
  const {
    isClickMotion: e,
    startClickMotion: f
  } = h();
  return /* @__PURE__ */ t(k, { $isClickMotion: e, ref: p, onClick: (g) => {
    a && a(g), f();
  }, "data-testid": "rango-profile-button", "data-rango-component": "rango-profile-button", "data-is-rango": !0, ...d, children: /* @__PURE__ */ r(c, { children: [
    /* @__PURE__ */ t(z, { children: /* @__PURE__ */ t(M, { $isClickMotion: e }) }),
    /* @__PURE__ */ r(I, { children: [
      /* @__PURE__ */ t(s, { children: o }),
      n && /* @__PURE__ */ t(l, { children: n })
    ] }),
    /* @__PURE__ */ t(w, { size: C.SM, icon: "NavigationRightLine" })
  ] }) });
});
N.displayName = "RangoProfileButton";
export {
  N as RangoProfileButton
};
